import React from 'react';
import { MarketScanConfig } from '../types';

interface HeroStarProps {
  config: MarketScanConfig;
}

export const HeroStar: React.FC<HeroStarProps> = ({ config }) => {
  return (
    <>
      {/* X-axis container animates left position */}
      <div 
        className="ms-hero-star-x"
        style={{ animationDuration: `${config.timing.introStarDurationMs}ms` }}
      >
        {/* Y-axis container animates top position + size */}
        <div 
          className="ms-hero-star-y"
          style={{ animationDuration: `${config.timing.introStarDurationMs}ms` }}
        >
          <img 
            src={config.header.logoSrc} 
            alt="Logo Outline" 
            className="ms-star-large" 
            style={{ filter: 'grayscale(1) brightness(0.8) opacity(0.3)' }} 
          />
          <img 
            src={config.header.logoSrc} 
            alt="Logo Fill" 
            className="ms-star-large ms-fill-layer" 
            style={{ 
              position: 'absolute', 
              top: 0, 
              left: 0,
              animationDuration: `${config.timing.introFillDurationMs}ms`,
              animationDelay: `${config.timing.introFillDelayMs}ms`
            }}
          />
        </div>
      </div>
    </>
  );
};
